import { stringify } from "qs";
import fetchClient from "api/client";
import CAMPAIGN_ENDPOINT from "api/campaign/campaignEndpoint";
import { DAYS_UNTIL_NEXT_ACTION } from "constants/common";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";

/**
 * @description GET api/campaign-deploy/:id
 * */
export default function getCampaignDeploy({
  queryKey: [, { id }, { page, perPage, sortBy, ...queryPrams }],
  signal,
}) {
  const queryString = stringify(
    {
      ...queryPrams,
      page: page || 0,
      sortBy: sortBy === "duno" ? DAYS_UNTIL_NEXT_ACTION : sortBy,
      ...getPerPageQueryParam(perPage),
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`${CAMPAIGN_ENDPOINT}-deploy/${id}${queryString}`, { signal });
}
